module.exports = __webpack_public_path__ + "images/stickers/taco-alert.1e2b686cc2cae4275e2b.png";